import{useEvent as o}from"../events.js";function t(t,c){o(t,"click",c.onClick)}export default t;
